// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLoader_wrapper__U3KY-"};